import React, { useState, useEffect } from 'react';

const DateTime = () => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000); // Update every second

    return () => {
      clearInterval(interval);
    };
  }, []);

  const formatDay = (date) => {
    const options = {weekday: 'long'};
    return date.toLocaleDateString(undefined, options);
  };

  const formatDate = (date) => {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  };

  const formatTime = (date) => {
    const options = { hour: 'numeric', minute: 'numeric', second: 'numeric' };
    return date.toLocaleTimeString(undefined, options);
  };

  return (
    <div class="datetime">
      <p>{formatDay(currentDateTime)}<br></br>
        {formatDate(currentDateTime)}<br></br>
      {formatTime(currentDateTime)}</p>
    </div>
  );
};

export default DateTime;
